import PropTypes from 'prop-types';
import { OverlayTriggerTooltip } from '@utilities';
import styles from './_index.module.scss';

const PromoCredits = ({
  firstName,
  lastName,
  onTogglePromoCredits,
  promoCredits,
  totalCost,
  usePromoCredits,
}) => {
  const hasSufficientCredits = promoCredits >= totalCost;

  return (
    <div className={styles['promo-credits']}>
      <div className={styles['promo-credits-header']}>
        PROMOTIONAL CREDITS FOR {`${firstName} ${lastName}`.toUpperCase()}
      </div>
      <div className={styles['promo-credits-content']}>
        <div className={styles['promo-credits-available-toggle']}>
          <span>Available -</span>
          {hasSufficientCredits ? (
            <span
              aria-label={
                usePromoCredits ? 'Remove promotional credits' : 'Apply promotional credits'
              }
              className={styles['promo-credits-toggle']}
              data-testid="apply-promo-link"
              onClick={onTogglePromoCredits}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onTogglePromoCredits();
                }
              }}
              role="button"
              tabIndex="0"
            >
              {usePromoCredits ? 'Remove' : 'Apply Now'}
            </span>
          ) : (
            <OverlayTriggerTooltip
              content=" Not enough credits to launch. Please contact your Numerator team for more
                  information on credits."
            >
              <span
                aria-label="Not enough promotional credits to launch"
                className={`${styles['promo-credits-toggle']} ${styles['disabled']}`}
                data-testid="apply-promo-link"
                role="button"
              >
                {usePromoCredits ? 'Remove' : 'Apply Now'}
              </span>
            </OverlayTriggerTooltip>
          )}
        </div>
        <span className={styles['promo-credits-amount']}>
          {promoCredits === 1 ? '1 credit' : `${promoCredits} credits`}
        </span>
      </div>
    </div>
  );
};

PromoCredits.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  onTogglePromoCredits: PropTypes.func.isRequired,
  promoCredits: PropTypes.number.isRequired,
  totalCost: PropTypes.number.isRequired,
  usePromoCredits: PropTypes.bool.isRequired,
};

export default PromoCredits;
